import { IdBodyFilter } from "../../../common/types/commonTypes";

export enum Sentiment {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
}

// backend allows any string
export enum RelatesTo {
  CASH_DIFF = "CASH_DIFF",
  AGE_CHECK = "AGE_CHECK",
}

export interface AckCustomerFeedbackToEntry extends IdBodyFilter {
  relatesTo?: RelatesTo;
  sentiment?: Sentiment;
}
